var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1764355048319,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 63710,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M732.16 399.36H291.84v-102.4c0-117.76 97.28-209.92 220.16-209.92s220.16 92.16 220.16 209.92v102.4z m-179.2 312.32v168.96c0 20.48-15.36 40.96-40.96 40.96s-40.96-20.48-40.96-40.96v-168.96c-25.6-15.36-51.2-46.08-51.2-76.8 0-46.08 40.96-81.92 87.04-81.92s87.04 35.84 87.04 81.92c5.12 30.72-15.36 66.56-40.96 76.8z m296.96-312.32h-25.6V302.08C824.32 128 686.08 0 512 0 337.92 0 199.68 128 199.68 302.08v97.28h-25.6c-56.32 0-107.52 46.08-107.52 102.4V921.6c0 56.32 46.08 102.4 107.52 102.4h675.84c56.32 0 107.52-46.08 107.52-97.28V501.76c0-56.32-51.2-102.4-107.52-102.4z",
    fill: "#3b82f6",
    "p-id": 63711
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessCode);
export default __webpack_public_path__ + "static/media/accessCode.d32c8e60ba9bd9faef4969fb7e4beb1d.svg";
export { ForwardRef as ReactComponent };